// Client-side counterpart of shared/lib/appUrls.js.
//
// Vue CLI only exposes VUE_APP_* env vars to the bundle, and they are baked in at
// build time. Defaults reproduce today's cdseo.com behaviour; set the vars in
// client/.env.production (or the build environment) for the octaneaco.com move.
//
//   VUE_APP_APP_DOMAIN     base domain shown as the workspace suffix       (cdseo.com)
//   VUE_APP_MARKETING_URL  marketing site for support/policy/install links (https://<domain>)
//   VUE_APP_SUPPORT_EMAIL  mailto target                                    (help@<domain>)

const env = (key, fallback) => {
  const value = ((process.env[key] || '') + '').trim()
  return value || fallback
}

export const APP_DOMAIN = env('VUE_APP_APP_DOMAIN', 'cdseo.com')
export const MARKETING_URL = env('VUE_APP_MARKETING_URL', `https://${APP_DOMAIN}`).replace(/\/+$/, '')
export const SUPPORT_EMAIL = env('VUE_APP_SUPPORT_EMAIL', `help@${APP_DOMAIN}`)

export default {
  domain: APP_DOMAIN,
  // ".cdseo.com" — for workspace subdomain fields
  workspaceSuffix: `.${APP_DOMAIN}`,
  marketing: MARKETING_URL,
  supportEmail: SUPPORT_EMAIL,
  supportMailto: `mailto:${SUPPORT_EMAIL}`,
  contact: `${MARKETING_URL}/pages/contact`,
  install: `${MARKETING_URL}/pages/install`,
  privacy: `${MARKETING_URL}/policies/privacy-policy`,
  terms: `${MARKETING_URL}/policies/terms-of-service`
}
